const getFullName = (firstName?: string, lastName?: string) =>
  [firstName, lastName].filter(Boolean).join(' ')

export default getFullName
